/* Table of contents for article pages.
   Builds a jump list from the h2/h3 elements inside .tpe-prose and
   injects it into #tpe-article-toc. No framework, no dependencies. */
(function () {
  function init() {
    var prose = document.querySelector('.tpe-prose');
    var nav = document.getElementById('tpe-article-toc');
    if (!prose || !nav) return;

    var headings = prose.querySelectorAll('h2');
    if (!headings.length) return;

    var list = document.createElement('ol');
    headings.forEach(function (h, i) {
      var id = 'tpe-section-' + (i + 1);
      h.setAttribute('id', id);

      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = h.textContent;
      a.addEventListener('click', function (e) {
        e.preventDefault();
        h.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      li.appendChild(a);
      list.appendChild(li);
    });

    nav.appendChild(list);
    nav.classList.remove('tpe-toc--hidden');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
